import { Component, Input, SimpleChanges } from '@angular/core';
import { ChartData } from '../../../../../../shared/models/depth-data';

@Component({
  selector: 'app-depth-detail',
  templateUrl: './depth-detail.component.html',
  styleUrl: './depth-detail.component.scss'
})
export class DepthDetailComponent {
  @Input() depth_detail: ChartData | null = null;
  @Input() isPiezo!: boolean;
  
  ngOnChanges(changes: SimpleChanges): void { 
    if (changes['depth_detail'] && this.depth_detail) { 
      this.sortDataByDate(); 
    } 
  } 
  
  sortDataByDate() { 
    if (this.depth_detail && this.depth_detail.result) { 
      this.depth_detail.result.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()); 
    } 
  }
}
